import React from "react";
import BlogThirtySix from "../component/BlogThirtySix";

function BlogThirtySixContainer() {
  return <BlogThirtySix />;
}

export default BlogThirtySixContainer;
